import React, { useState } from 'react';
import { Box, Typography, Link } from '@mui/material';

interface ReadMoreTextProps {
  children: React.ReactNode;
  clampLines?: number;
  sx?: object;
}

// Collapses long body copy behind a "Read more" toggle on mobile only;
// desktop always shows the full text.
const ReadMoreText: React.FC<ReadMoreTextProps> = ({ children, clampLines = 4, sx }) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <Box sx={{ mb: { xs: 2, md: 2 }, ...sx }}>
      <Typography
        variant="body2"
        sx={{
          fontSize: { xs: '0.9rem', md: '1rem' },
          lineHeight: { xs: 1.4, md: 1.5 },
          maxWidth: { xs: '65ch', md: '65ch' },
          display: { xs: '-webkit-box', md: 'block' },
          WebkitBoxOrient: { xs: 'vertical', md: 'unset' },
          WebkitLineClamp: { xs: expanded ? 'unset' : clampLines, md: 'unset' },
          overflow: { xs: expanded ? 'visible' : 'hidden', md: 'visible' },
        }}
      >
        {children}
      </Typography>
      <Link
        component="button"
        type="button"
        onClick={() => setExpanded((prev) => !prev)}
        underline="hover"
        sx={{
          display: { xs: 'inline-block', md: 'none' },
          mt: 0.5,
          fontSize: '0.85rem',
          fontWeight: 600,
        }}
      >
        {expanded ? 'Read less' : 'Read more'}
      </Link>
    </Box>
  );
};

export default ReadMoreText;
